import { mapState } from 'vuex';
import {
  EntrancePlantDetailDTO,
  GateGuestDTO,
} from '@/../client-generator/generated-clients/plants';
import { PropType } from 'vue';
import { Options, Vue } from 'vue-class-component';
import KeypadCodeInput from '@/views/components/KeypadCodeInput/KeypadCodeInput.vue';
import { getAllKeypadCodes } from '@/core/utils/EntrancePlant/entrance-plant.utils';

@Options({
  name: 'CodeTab',
  props: {
    editingGuest: {
      type: Object as PropType<GateGuestDTO>,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
    updateGuesttKey: {
      type: Number,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  components: { KeypadCodeInput },
  emits: ['key-code-edited', 'error-key-code'],
})
export default class CodeTab extends Vue {
  editingGuest!: GateGuestDTO;
  currentEntrancePlant!: EntrancePlantDetailDTO;
  isEdit!: boolean;
  disabled!: boolean;
  codeTabHasError = false;
  keypadCodeEdited = false;
  keypadCode = '';
  updateGuesttKey!: number;

  get alreadyUsedCodes() {
    return getAllKeypadCodes(this.currentEntrancePlant);
  }

  created() {
    if (this.editingGuest.keypadCode)
      this.keypadCode = this.editingGuest.keypadCode;
  }

  guestWasEdited() {
    this.$emit('error-key-code', this.codeTabHasError);
    this.$emit('key-code-edited', this.keypadCodeEdited, this.keypadCode);
  }

  handleKeypadCodeEdited(value: boolean, code: string) {
    this.keypadCodeEdited = value;
    if (!this.codeTabHasError) {
      this.keypadCode = code;
      this.guestWasEdited();
    }
  }

  handleErrorKeyCode(value: boolean) {
    this.codeTabHasError = value;
    this.guestWasEdited();
  }
}
